import CheckoutWrapper from '@/layout/CheckoutWrapper.vue';
import Vue from 'vue';
import { debounce } from 'vue-debounce';
import { mapState } from 'vuex';
import { $httpChangiRecommends } from '@/core/api';
import PaymentVerification from '@/modules/checkout/components/PaymentVerification.vue';
// @todo handle status updates
export default Vue.extend({
    components: {
        CheckoutWrapper,
        PaymentVerification,
    },
    computed: {
        ...mapState('checkoutModule', ['settledOrder']),
    },
    data() {
        return {
            confirmed: false,
            failed: false,
            payersName: '',
            payersMobile: '',
            timerCount: 0,
            remainingPayment: 0,
        };
    },
    created() {
        this.timerCount = this.settledOrder?.paymentDetails.qrCodeExpireTimeSeconds;
        let watchInterval = setInterval(() => {
            $httpChangiRecommends.api
                .ChangiRecommendsOrderPaymentStatus(this.settledOrder?.orderUuid)
                .then((resp) => {
                this.remainingPayment = resp.data.result.remaining_to_be_paid;
                if (resp.data.result.isPaid) {
                    this.confirmed = true;
                    clearInterval(watchInterval);
                    setTimeout(() => {
                        this.$router.push({ name: 'CheckoutConfirmation' });
                    }, 2000);
                }
            });
        }, 5000);
    },
    methods: {
        formatTime() {
            let time = this.timerCount;
            if (time < 1) {
                return;
            }
            let mins = ~~((time % 3600) / 60);
            let secs = ~~time % 60;
            let ret = '';
            ret += '' + mins + ':' + (secs < 10 ? '0' : '');
            ret += '' + secs;
            return ret;
        },
    },
    watch: {
        timerCount: debounce(function (newVal) {
            if (newVal > 0) {
                this.timerCount = this.timerCount - 1;
            }
            else {
                this.failed = true;
            }
        }, 1000),
    },
});
